import request from './request';

// 维修产值统计-图表
export function getClueAmount(params) {
    return request('/stat/clue/amount/view', {
        method: 'POST',
        params,
    });
}

// 维修产值统计-列表
export function getClueAmountList(params) {
    return request('/stat/clue/amount/list', {
        method: 'POST',
        params,
    });
}
